'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ZoomboxIcon = function ZoomboxIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 16 16' }, props),
        _react2.default.createElement('path', { d: 'M16 14l-4-4.017A6.456 6.456 0 0 0 13 6.5a6.501 6.501 0 0 0-13 0C0 10.089 2.923 13 6.512 13a6.45 6.45 0 0 0 3.495-1L14 15.993 16 14zM3 10V3h7v7H3zm1-6h5v5H4V4z' })
    );
};

exports.default = ZoomboxIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/plotly-icons/lib/components/ZoomboxIcon.js
// module id = 738
// module chunks = 0